import { CaretRightOutlined } from '@ant-design/icons';
import style from './index.module.less'
import React, {forwardRef, useEffect, useImperativeHandle, useState, useReducer, useRef} from "react";
import {getImagePathWithTheme, isDarkMode} from "@/utils";
import {FROM_JOURNAL, FROM_PAGE_CARD, FROM_SIDEBAR_FOLD} from "@/Const";
import {useAtom} from "jotai";
import {atomHomePaddingLeft} from "@/views/Home/HomeIndex";
import {t} from "i18next";
import global from "@/global";


const HeadingTree = forwardRef((props: { editor: any,onCollapseCallback?:any,from?:any,data?:any }, ref) => {

	useImperativeHandle(ref,()=>({
		onRefreshHeadings:onRefreshHeadings
	}))

	const editor = props.editor || window.GEditor

	const [isOutlineVisible, setOutlineVisible] = useState(true)
	const [closedHeadings, setClosedHeading] = useState([])
	const [headings, setHeadings] = useState([])

	const [title, setTitle] = useState<string>('')
	const [width,setWidth] = useState('0');

	const itemRefs = useRef({});

	const [homePaddingLeft,setHomePaddingLeft] = useAtom(atomHomePaddingLeft)

	const refreshHeadings = () => {
		const headings: any[] = []
		let l1El = 0,
			l2El = 0,
			l3El = 0,
			l4El = 0,
			l5El = 0,
			l6El = 0,
			pId = '',
			index = 0;
		editor.state.doc.descendants((node, pos) => {

			if (node.type.name === 'heading') {
				if (node.attrs["level"] < 7) {

					let elP = 0
					if (node.attrs["level"] === 1) {
						l1El++
						elP = l1El
						// if(l1El === 1) return
						// pId = node.textContent + l1El + l2El
					} else if (node.attrs["level"] === 2) {
						l2El++
						elP = l2El
					}else if (node.attrs["level"] === 3) {
						l3El++
						elP = l3El
					} else if (node.attrs["level"] === 4) {
						l4El++
						elP = l4El
					} else if (node.attrs["level"] === 5) {
						l5El++
						elP = l5El
					} else {
						l6El++
						elP = l6El
					}

					let top = document.querySelectorAll(`.ProseMirror h${node.attrs["level"]}`)[elP - 1]?.offsetTop
					headings.push({
						index,
						text: node.textContent,
						level: node.attrs["level"],
						id: node.textContent + '_id_' + l1El + l2El + l3El + l4El + l5El + l6El,
						// id: '_id_' +l1El + l2El + l3El,
						pos: pos,
						elP: elP - 1,  // 元素位置
						top,
						dataId: node.attrs["id"],
						ifFold: node.attrs["fold"],
						attrs: node.attrs,
						ifClick: false
					})

					index++
				}
			}
		})

		/**  计算pId */
		if (headings[0]) {
			headings[0].pId = ''
		}


		/** 优化后的pId计算 */
		function calculateParentIds(headings) {
			// 使用栈来跟踪每个层级的最新父节点
			const parentStack = new Array(7).fill(null); // 支持1-6级标题

			for (let i = 0; i < headings.length; i++) {
				const current = headings[i];
				const level = current.level;

				// 更新当前层级的节点
				parentStack[level] = current;

				// 清空比当前层级更深的所有层级
				for (let j = level + 1; j < 7; j++) {
					parentStack[j] = null;
				}

				// 寻找父节点：从当前层级-1开始向上查找
				let parentId = '';
				for (let parentLevel = level - 1; parentLevel >= 1; parentLevel--) {
					if (parentStack[parentLevel]) {
						parentId = parentStack[parentLevel].id;
						break;
					}
				}

				current.pId = parentId;
			}

			return headings;
		}

		// 应用优化后的计算
		calculateParentIds(headings);

		// 更新 hasChild 标记

		const { scrollTop } = document.querySelector('#EDITOR_SCROLL_BOX') || {}
		for (let idx = 0; idx < headings.length; idx += 1) {
			const current = headings[idx]
			const next = headings[idx + 1]
			if (next) {
				current.hasChild = current.level < next.level
			}
			// if(!clickId){
			current.active = current.top <= scrollTop && (!next || next.top > scrollTop)
			// }else if(current.id === clickId) {
			// 	current.active = true
			// }
			headings[idx] = current
		}

		// 更新 collapsed 和 visible 标记
		for (let idx = 0; idx < headings.length; idx += 1) {
			const current = headings[idx]
			// console.log('closedHeadings: ', closedHeadings);
			if (closedHeadings.includes(current.pid)) {
				current.collapsed = true
			}

			// 一级标题，一定显示，其他找到最近的 parent
			// current.invisible = false
			// if (current.level > 1) {
			// 	for (let descIdx = idx - 1; descIdx >= 0; descIdx -= 1) {
			// 		const prev = headings[descIdx]
			// 		if (prev.level < current.level) {
			// 			current.invisible = !!(prev.invisible || prev.collapsed)
			// 			break
			// 		}
			// 	}
			// }
		}

		setHeadings(headings)
	}

	const handleTriangleClick = (e, item) => {
		e.stopPropagation()
		// setClosedHeading([...closedHeadings.filter(x => x !== item.id)])
		// if (closedHeadings.includes(item.id)) {
		// } else {
		// 	setClosedHeading([item.id, ...closedHeadings])
		// }

		setClosedHeading(self => {
			if (self.includes(item.id)) {
				self = self.filter(x => x !== item.id)
			} else {
				self = [...self, item.id]
			}

			// return []
			return self
		})


	}

	const handleHeadlineClick = (e,item) => {
		e.stopPropagation()
		const { state, view } = editor
		let tr
		let parentHeading
		let parentHeadingIndex = item.level === 1 ? -1 : headings.findIndex(heading => heading.id === item.pId);
		while (parentHeadingIndex !== -1) {
			parentHeading = headings[parentHeadingIndex]
			if (parentHeading.ifFold) {
				// 改变图标的状态
				// const selectNodeNP = editor.$doc.querySelectorAll('heading', { id: parentHeading.dataId })[0]
				// debugger
				tr = state.tr.setNodeMarkup(parentHeading.pos, state.schema.nodes['heading'], {
					...parentHeading.attrs,
					fold: false
				});
				// 改变所属节点的隐藏显示状态
				// 1,确定节点所属部分
				let foldContentArr = []
				let startCompute = false
				state.doc.descendants((node, pos) => {
					if (node.type.name === 'heading' && node.attrs.id === parentHeading.dataId) {
						startCompute = true;
					} else if (startCompute && node.type.name !== 'text') {
						if (node.type.name !== 'heading' || (node.type.name === 'heading' && node.attrs.level > parentHeading.level)) {
							foldContentArr.push({
								node: node,
								pos: pos
							})
						} else {
							startCompute = false;
						}
					}
				});
				// 2,改变节点所属部分的显示状态
				foldContentArr.forEach((ele) => {
					const attrs={
						...ele.node.attrs,
						ifhidden: false
					}
					if(ele.node.type.name==='heading'){
						attrs.fold=false
					}
					tr.setNodeMarkup(ele.pos, state.schema.nodes[`${ele.node.type.name}`], attrs);
				})
				// tr = tr.setNodeMarkup(paragraphNP.pos - 1, schema.nodes.paragraph, {
				//   ...paragraphNP.attributes,
				//   ifhidden: !paragraphNP.attributes.ifhidden
				// });
			}
			parentHeadingIndex = parentHeading.level === 1 ? -1 : headings.findIndex(heading => heading.id === parentHeading.pId);
		}
		if (tr) {
			view.dispatch(tr);
		}

		// 设置标记，表示这次选择是来自 HeadingTree
		window.isHeadingTreeSelection = true

		let divContainer:any = null;//document.getElementById('div-editor-scroll-container');
		if (window.getCardScrollContainer){
			divContainer = window.getCardScrollContainer();
		}
		let nOriTop = divContainer?.scrollTop || 0;

		editor.chain().focus()
			.setNodeSelection(item.pos)
			.scrollIntoView({ block: 'start' })
			.run()

		editor.chain().focus()
			.setTextSelection({
				from: editor.state.selection.from,
				to: editor.state.selection.from
			})
			.run()

		let els = document.querySelectorAll(`.ProseMirror h${item.level}`)[item.elP];
		els.scrollIntoView({ block: 'center' })
		// els.innerHTML = '<span style="color:black !important;">' + item.text + '</span>'

		//选中这个东西...
		// const selection = NodeSelection.create(editor.state.doc, item.pos);
		// editor.view.dispatch(editor.state.tr.setSelection(selection));
		global.g_isFromHeadClicked = true;
		editor.commands.setNodeSelection(item?.pos);
		editor.commands.blur();
		setTimeout(()=>{
			editor.commands.blur();
		},100);




		// setTimeout(() => {
		// 	els.innerHTML = item.text;
		// 	if (divContainer){
		// 		let nScrollTop = divContainer.scrollTop;
		// 		if (nOriTop > nScrollTop){
		// 			nScrollTop -= document.body.clientHeight*0.5
		// 		}else{
		// 			nScrollTop += document.body.clientHeight*0.5;
		// 		}
		// 		divContainer.scrollTo({
		// 			top: nScrollTop,
		// 		})
		// 	}
		// }, 100)
		refreshHeadings()
	}

	function findNodeById(doc: Node, targetId: string) {
		let result: { node: Node; pos: number; parentPos: number | null } | null = null;

		doc.descendants((node, pos) => {
			// 检查当前节点是否有 attrs.id 且匹配
			if (node.attrs?.id === targetId) {
				// 找到目标节点
				const $pos = doc.resolve(pos);

				// 获取父节点位置（安全检查 depth > 0）
				const parentPos = $pos.depth > 0 ? $pos.before($pos.depth) : null;

				result = { node, pos, parentPos };
				return false; // 停止遍历
			}
		});

		return result;
	}

	/**
	 * 刷新目录
	 */
	const onRefreshHeadings = ()=>{
		refreshHeadings()
	}

	const handleHeadingClick = (event) => {
		setHeadings(prevHeadings=>{
			for (let i = 0; i < prevHeadings.length; i++) {
				if(prevHeadings[i].dataId===event.detail.id){
					prevHeadings[i].ifClick=true;
					const targetRef = itemRefs.current[i];
					if (targetRef) {
						targetRef.scrollIntoView({
							behavior: 'smooth',
							block: 'center',
						});
					}
				}else{
					prevHeadings[i].ifClick=false;
				}
			}
			return [...prevHeadings]
		})
	}

	useEffect(() => {
		if (isOutlineVisible) {
			refreshHeadings()
		}
	}, [editor, isOutlineVisible])

	useEffect(() => {
		const handleUpdate = () => {
			refreshHeadings()
		}

		onWindowResize();

		setTitle(props.data?.name)

		editor.on("selectionUpdate", handleUpdate)
		editor.on("update", handleUpdate)
		let timer = setInterval(() => {
			setTitle(props.data?.name)
			// 	if(headings.length){
			// 		// console.log('headings: ', headings);
			// 	const { scrollTop } = document.querySelector('#EDITOR_SCROLL_BOX') || {}
			// 	for (let i = headings.length - 1; i >= 0; i--) {
			// 		console.log('scrollTop: ', scrollTop, headings[i].top);
			// 		if (headings[i].top <= scrollTop) {
			// 			setHeadings((self) => {
			// 				self.map((item, j) => {
			// 					item.active = j === i
			// 					console.log('item.active: ', item.active);
			// 					// console.log('self[j]: ', self[j]);
			// 				})
			// 				// console.log('self: ', self);
			// 				return self
			// 			})
			// 			break
			// 		}
			// 	}
			// 	}
		}, 200)

		document.querySelector('#EDITOR_SCROLL_BOX')?.addEventListener('scroll', handleUpdate);
		document.addEventListener('headingClick', handleHeadingClick);

		return () => {
			editor.off("selectionUpdate", handleUpdate)
			editor.off("update", handleUpdate)
			clearInterval(timer)
			document.querySelector('#EDITOR_SCROLL_BOX')?.removeEventListener('scroll', handleUpdate)
			document.addEventListener('headingClick', handleHeadingClick);
		}
	}, [])

	const getWidth = ()=>{
		let nWidth = document.body.clientWidth;
		if (props.from == FROM_PAGE_CARD){
			nWidth -= homePaddingLeft;
		}
		nWidth =  nWidth/5;
		if (nWidth > 250){
			nWidth = 250;
		}
		return nWidth + 'px';
	}

	/**
	 *
	 */
	function onWindowResize(){
		setWidth(getWidth())
	}

	useEffect(()=>{
		window.addEventListener('resize',onWindowResize);

		return ()=>{
			window.removeEventListener('resize',onWindowResize);
		}
	})

	const [expand, setExpand] = useState<boolean>((props.from == FROM_JOURNAL)?false:true)

	// if (!headings.length) return null;

	const getMarginTop = ()=>{
		if (props.from == FROM_JOURNAL){
			return '14px'
		}else if (props.from == FROM_PAGE_CARD){
			return '22px';
		}else if (props.from == FROM_SIDEBAR_FOLD){
			return '10px';
		}
		return '90px';
	}

	const renderIcon = ()=>{
		if (props.from == FROM_SIDEBAR_FOLD){
			return <></>
		}
		if (headings.length == 0){
			return <></>
		}

	}

	return (
		<>
			<div className={style.HeadingTreeStyle} style={{width:props.from == FROM_SIDEBAR_FOLD?'100%':width,position:'absolute',top:getMarginTop(),paddingRight:'22px',height:props.from == FROM_SIDEBAR_FOLD?'calc(100% - 10px)':'auto'}}>
				{
					(props.from == FROM_SIDEBAR_FOLD || headings.length == 0) ? <></>:
					expand ? (
						<img className={'img-16 cursor-pointer'} src={getImagePathWithTheme('note_menu_head_collapse')} onClick={() => {
							setExpand(false);
							if (props.onCollapseCallback){
								props.onCollapseCallback(false);
							}
						}} />
					) : <img className={'img-16 cursor-pointer'} src={getImagePathWithTheme('note_menu_head_expand')} onClick={() => {
						setExpand(true);
						if (props.onCollapseCallback){
							props.onCollapseCallback(true);
						}
					}} />
				}


				{headings.length > 0 && expand && <div className="headline-container" style={{marginLeft:'-7px'}}>
					<div className="headline-content">
						<div className={`${style.tree} ${style.level1}`} onClick={() => {
							document.querySelector(`#NOTE_TITLE_INPUT-${props.data?.id}`).focus()
							document.querySelector(`#NOTE_TITLE_INPUT-${props.data?.id}`).style.background = '#e6f4ff'
							setTimeout(() => {
								document.querySelector(`#NOTE_TITLE_INPUT-${props.data?.id}`).style.background = 'none'
							}, 600)
						}} style={{marginLeft:'8px'}}> {title}</div>
						{headings.map((heading,index) => {
							if (heading.invisible) return null;
							const { id, level, text, hasChild = false, active = false, pId } = heading
							const collapsed = heading.collapsed//closedHeadings.includes(pId)
							if (closedHeadings.includes(pId)) return null
							if (level === 3 && pId) {
								const ppId = headings.find(item => item.id === pId).pId
								if (closedHeadings.includes(ppId)) return null
							}
							return <div key={id} className={`${style.tree} `} onClick={(e) => handleHeadlineClick(e,heading)}  ref={(el) => itemRefs.current[index] = el}>
								<div className={`${style['level' + level]} ${active ? style.act : null} ${style.hoverIcon}`}>
									{hasChild && <CaretRightOutlined className={`${style.icon} ${!collapsed ? style.open : style.close}`} style={{width:'16px',height:'16px',color:isDarkMode()?'white':'black'}}
																	 onClick={(e) => {
																		 e.stopPropagation();
																		 setHeadings(prevHeadings => {
																			 const newHeadings = [...prevHeadings];
																			 // 找到被点击的 heading 索引
																			 const index = newHeadings.findIndex(h => h.id === heading.id);
																			 if (index === -1) return newHeadings;
																			 // 切换折叠状态
																			 newHeadings[index].collapsed = !newHeadings[index].collapsed;
																			 const parentLevel = newHeadings[index].level;
																			 const isCollapsing = newHeadings[index].collapsed;
																			 // 从当前节点往后遍历，找到所有比当前层级大的标题
																			 for (let i = index + 1; i < newHeadings.length; i++) {
																				 if (newHeadings[i].level <= parentLevel) break; // 遇到同级或上级标题就停止
																				 // 控制显示/隐藏
																				 newHeadings[i].invisible = isCollapsing;
																			 }
																			 return newHeadings;
																		 });
																	 }}
									/>}
									<div style={{marginLeft:'8px',color: heading.ifClick? 'rgb(128, 151, 193)':'var(--text-color)'}}>{text}</div>
								</div>
							</div>
						})}
					</div>
				</div>}
				{
					props.from == FROM_SIDEBAR_FOLD && headings.length == 0 &&
					<span style={{color: 'var(--color-666666)',marginTop:'12px',display:'block'}}>{t("Table of content")}</span>
				}
			</div>
		</>
	)
});

export default HeadingTree


















